import React from "react";
import { Helmet } from "react-helmet-async";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Możesz tu dodać logowanie do zewnętrznego serwisu
    // console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Helmet>
            <title>Błąd aplikacji | DJ Kusy</title>
            <meta name="robots" content="noindex" />
          </Helmet>
          <h1 style={{ fontSize: "2.5rem", color: "#e53e3e" }}>Coś poszło nie tak</h1>
          <p style={{ marginBottom: 16 }}>Wystąpił nieoczekiwany błąd. Odśwież stronę lub wróć na <a href="/" style={{ color: "#3182ce", textDecoration: "underline" }}>stronę główną</a>.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
